<template>
  <div>
    <p class="font-weight-medium body-1 text-center blue-grey--text">
      ¿La especie que quieres agregar no aparece en tu búsqueda?
    </p>
    <div class="d-flex justify-center">
      <v-btn
        @click="dialogRegisterOrganism = true"
        color="secondary"
        rounded
        large
        class="font-weight-bold"
        >Solicitar nueva especie</v-btn
      >
    </div>

    <!-- Dialogs -->
    <v-dialog v-model="dialogRegisterOrganism" max-width="700">
      <v-card>
        <v-card-title class="primary--text"
          >¿La especie que quieres agregar no aparece en tu
          búsqueda?</v-card-title
        >
        <v-card-subtitle
          >Completa el siguiente formulario para notificar a los
          administradores</v-card-subtitle
        >
        <v-divider></v-divider>
        <div class="ma-4">
          <div style="position:relative">
            <OrganismGallery
              v-on:update:attachementList="
                list => (formDataOrganism.attachementList = list)
              "
              :editable="true"
            ></OrganismGallery>
          </div>
          <v-divider></v-divider>

          <v-text-field
            v-model="formDataOrganism.vernacularName"
            label="Nombre"
            outlined
            rounded
            class="mt-8"
          ></v-text-field>
        </div>
        <v-card-actions>
          <v-btn text @click="dialogRegisterOrganism = false" color="primary"
            >Volver</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirmRequest" large rounded>
            <span>Solicitar nueva especie</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRequestSuccess" max-width="500">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="success" />
          <p class="font-weight-medium text-center title">
            Solicitud enviada correctamente
          </p>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRequestFailed" max-width="500">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="error" />
          <p class="font-weight-medium text-center title">
            Ha ocurrido un error enviando la solicitud
          </p>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import OrganismGallery from "../Organism/OrganismGallery";

export default {
  components: { OrganismGallery },
  data: () => ({
    formDataOrganism: {
      attachementList: []
    },
    dialogRegisterOrganism: false,
    dialogRequestSuccess: false,
    dialogRequestFailed: false
  }),
  computed: {
    practitionerLogged() {
      return this.$store.getters["authPractitioner/getPractitioner"];
    }
  },
  methods: {
    async confirmRequest() {
      try {
        this.dialogRegisterOrganism = false;
        this.loading = true;
        let { data: organismCreated } = await this.$http.post("organism", {
          ...this.formDataOrganism,
          attachementList: undefined,
          recordedBy: this.practitionerLogged.id,
          validated: false
        });
        for (let attachement of this.formDataOrganism.attachementList) {
          await this.$http.post("attachement", {
            archive: attachement.archive.id,
            organism: organismCreated.id,
            type: "organismProfile"
          });
        }

        this.dialogRequestSuccess = true;
        this.formDataOrganism = {};
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    }
  }
};
</script>

<style></style>
